import { jsx, Fragment } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { pseudoDot, textTone } from "./DotSeparator.css.mjs";
const dotText = "•";
const DotSeparator = ({ content }) => /* @__PURE__ */ jsx(Fragment, { children: content.map((item, index) => {
  const { text, tone } = typeof item === "string" ? { text: item, tone: void 0 } : item;
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: "inline",
      className: [pseudoDot, tone && textTone[tone]],
      children: text
    },
    `dotSeparator_${index}`
  );
}) });
export {
  DotSeparator,
  dotText
};
